
export const ADD_PERSON = "ADD_PERSON"



// WEBPACK FOOTER //
// ./src/actions/action-types.js